import ModalLayout, { DockPosition } from "components/ModalLayout";
import styles from "./styles.module.scss";
import CloseIcon from "assets/icons/close.svg?react";
import { useContext, useEffect, useRef, useState } from "react";
import ModalsManagerContext from "contexts/ModalsManager";
import SearchCasesNew from "components/SearchCasesNew";
import Button from "components/Button";
import { IPackage } from "dto/IPackage";
import { getUserId } from "utils/getUserId";
import { useAuth } from "react-oidc-context";
import { getKeys } from "utils/getKeys";
import { axiosInstance } from "api/axios";
import { decryptPrivateKey } from "utils/decryptPrivateKey";
import { readFileFromBase64 } from "utils/readFileFromBase64";
import * as openpgp from "openpgp";
import { readAsBase64 } from "utils/readAsBase64";
import { ItemKind } from "dto/IKindItems";
import { generateSingleBinary } from "utils/GenerateSingleBinary";
import casesService, { IAttachToCaseFolderLink } from "api/casesService";
import { ENotificationType, notification } from "utils/notification";
import PackagesContext from "contexts/PackagesContext";
import { useNavigate, useParams } from "react-router-dom";
import { ICaseSimple } from "dto/Cases/ICaseSimple";
import { useThreadStore } from "store/thread.store";
import HollowButton from "components/HollowButton";
import { IDossierItem } from "dto/Dossier/IDossierItem";
import AttachIcon from "assets/icons/folder_dossier_added.svg?react";
import TeamIcon from "assets/icons/team.svg?react";
import { IAttachment } from "dto/IAttachment";
import PackageAttachment from "components/PackageAttachment";
import { useOnClickOutside } from "hooks/useClickOutside";
import DropIcon from "assets/icons/drop.svg?react";
import MoveIcon from "assets/icons/logout.svg?react";
import PackageThreadContext from "contexts/PackageThreadContext";
import { logError } from "utils/loggerToBE";
import { IKey } from "dto/IKey";
import classNames from "classnames";
import usePDF from "hooks/usePDF";
import Spinner from "components/Spinner";
import { useDrag, useDrop } from "react-dnd";
import ListControl from "components/ListControl";
import { ListItem } from "components/ListControl/typings";
import { ICaseParticipant } from "dto/Cases/ICaseParticipant";
import { CaseParticipantGroup } from "dto/Cases/CaseParticipantGroup";
import Placeholder from "assets/placeholder.png";
import { randomString } from "utils/randomString";
import { Option } from "components/OptionsCard/typings";
import BinIcon from "assets/icons/bin.svg?react";
import LabelIcon from "assets/icons/label-new.svg?react";
import DotsIcon from "assets/icons/three-dots.svg?react";
import Dropdown from "components/OptionsCard/Dropdown";
import settingsContext, { IOptionType } from "contexts/SettingsContext";
import AttachToCaseModalAttachments from "./AttachToCaseModalAttachments";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  LinearProgress,
  Tooltip,
} from "@mui/material";
import CourtIcon from "assets/icons/court.svg?react";
import LayoutContext, { ILayoutSizes } from "contexts/LayoutContext";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import CaseChatContext from "contexts/CaseChatContext";
import ConverstationContext from "contexts/ConversationContext";
import NotFoundScreen from "components/NotFoundScreen";
import DossierFilesContext from "contexts/DossierFilesContext";
import SearchLabel from "components/SearchLabel";
import { ITag, TagType } from "dto/ITag";
import TagBadge from "components/TagBadge";
import { faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ShowPreviewModal from "components/ShowPreviewModal";
import { getCompanyId as getWorkspaceId } from "utils/getCompanyId";
import workspaceService from "api/workspaceService";
import { reEncrypt } from "utils/reEncrypt";
import CasesContext from "contexts/CasesContext";
import { useTranslation } from "react-i18next";

const Participant = ({
  part,
  showGroup,
  showOptions,
  group,
  onRemove,
  onMove,
  afterEdit,
}: {
  part: ICaseParticipant;
  showGroup: boolean;
  showOptions: boolean;
  group?: CaseParticipantGroup;
  onRemove?: (participant: ICaseParticipant) => void;
  onMove: (participant: ICaseParticipant, toCc: boolean) => void;
  afterEdit: (participant: ICaseParticipant) => void;
}) => {
  const { t } = useTranslation();
  const [showDropdown, setShowDropdown] = useState<boolean>(false);
  const [options, setOptions] = useState<Option[]>([]);
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [name, setName] = useState<string>(part.Label);
  const [nameTmp, setNameTmp] = useState<string>(part.Label);
  const refWrapper = useRef();
  const refEditInput = useRef();

  // useOnClickOutside(refEditInput, () => {
  //   if (isEditing) {
  //     commitName(name);
  //   }
  // });

  const [, dragRef] = useDrag(
    () => ({
      type: "participant",
      canDrag: () => true,
      item: { id: part.Id },
      collect: (monitor) => ({
        isDragging: !!monitor.isDragging(),
      }),
    }),
    [],
  );

  useEffect(() => {
    const opt =
      group != null
        ? [
            {
              name: t("common.delete"),
              Icon: BinIcon,
              callback: () => {
                onRemove(part);
              },
              additional: false,
              isEnabled: true,
              canMultiple: true,
            },
            {
              name: t("common.edit"),
              Icon: LabelIcon,
              callback: () => {
                setIsEditing(true);
              },
              additional: true,
              isEnabled: true,
              canMultiple: true,
            },
          ]
        : [];

    if (group == null || group === CaseParticipantGroup.Cc) {
      opt.push({
        name: t("participants.moveTo"),
        Icon: MoveIcon,
        callback: () => {
          onMove(part, false);
        },
        additional: false,
        isEnabled: true,
        canMultiple: true,
      });
    }

    if (group == null || group === CaseParticipantGroup.Normal) {
      opt.push({
        name: t("participants.moveToCc"),
        Icon: MoveIcon,
        callback: () => {
          onMove(part, true);
        },
        additional: false,
        isEnabled: true,
        canMultiple: true,
      });
    }

    setOptions(opt);
  }, [showOptions]);

  const commitName = (val?: string) => {
    console.log("Setting name", val ?? name);
    part.Name = val ?? name;
    part.Label = val ?? name;
    setNameTmp(val ?? name);
    afterEdit(part);
    setIsEditing(false);
  };

  return (
    <div className={classNames(styles.participant)} ref={dragRef}>
      <div className={styles.name}>
        <img src={Placeholder} />
        {!isEditing && <>{part.Label ?? part.Name}</>}
        {isEditing && (
          <div className={styles.inlineEditor}>
            <input
              ref={refEditInput}
              autoFocus={true}
              className={styles.newFolderInput}
              defaultValue={part.Label}
              onBlur={(e) => setName(e.target.value)}
              placeholder={t("participants.subjectName")}
              id="input_editLabel"
              onKeyDownCapture={(e) => {
                if (e.key === "Enter") {
                  const i = e.target as HTMLInputElement;
                  commitName(i.value);
                } else if (e.key === "Escape") {
                  setIsEditing(false);
                }
                e.stopPropagation();
              }}
              onClickCapture={(e) => e.stopPropagation()}
            ></input>
            <HollowButton
              className={styles.smallButton}
              text={t("common.cancel")}
              onClick={() => {
                setName(nameTmp);
                setIsEditing(false);
              }}
            ></HollowButton>
            <Button
              text={t("common.save")}
              onClick={() =>
                commitName((refEditInput.current as HTMLInputElement).value)
              }
              className={styles.smallButton}
            ></Button>
          </div>
        )}
      </div>
      {showGroup && (
        <div className={styles.group}>
          {part.Group === CaseParticipantGroup.Normal ? "Do" : "Dw"}
        </div>
      )}
      {showOptions && (
        <div className={styles.more} ref={refWrapper}>
          <Tooltip title={t("common.more")}>
            <div>
              <DotsIcon
                onClick={() => {
                  setShowDropdown(!showDropdown);
                }}
                className={styles.icon}
              />
            </div>
          </Tooltip>
          {showDropdown && (
            <div className={styles.dropdown}>
              <Dropdown
                toggle={() => setShowDropdown(false)}
                options={options}
                refWrapper={refWrapper}
                rightSide={false}
                scrollWrapper={refWrapper}
                showOptions={showOptions}
                selectedElements={[]}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const AttachToCaseModalParticipants = ({
  toggle,
  caseId,
  pack,
  position,
}: {
  toggle(value: boolean): void;
  caseId: string;
  pack: IPackage;
  position: "left" | "center";
}) => {
  const { t } = useTranslation();
  const ref = useRef(null);
  const [sizes, setSizes] = useState<ILayoutSizes>({
    width: 50,
    height: 50,
    isDraging: false,
  });

  const { mutate: compareParticipants, isLoading } =
    casesService.useCompareParticipants();
  const { data: caseData } = casesService.useGetCase(caseId, null, true);
  const { mutate: saveCase, isLoading: isSavingCase } =
    casesService.useCreateCase();

  const [newParticipants, setNewParticipants] = useState<ICaseParticipant[]>(
    [],
  );
  const [selectedParticipants, setSelectedParticipants] = useState<ListItem[]>(
    [],
  );

  const [normalParticipants, setNormalParticipants] = useState<
    ICaseParticipant[]
  >([]);
  const [selectedNormalParticipants, setSelectedNormalParticipants] = useState<
    ListItem[]
  >([]);

  const onDrop = (item: any) => {
    const id = item.id;

    if (selectedParticipants.length < 2) {
      const part = newParticipants.find((x) => x.Id === id);

      if (part) {
        const newParticipants2 = [...newParticipants].filter(
          (x) => x.Id !== id,
        );
        setNewParticipants(newParticipants2);
        setNormalParticipants([...normalParticipants, part]);
      }
    } else {
      selectedParticipants.forEach((s) => {
        const part = newParticipants.find((x) => x.Id === s.Id);

        if (part) {
          setNewParticipants((old) => [...old].filter((x) => x.Id !== s.Id));
          setNormalParticipants((old) => [...old, part]);
        }
      });
    }
  };

  const handleRemove = (item: ICaseParticipant) => {
    const normalToRemove = normalParticipants.find((x) => x.Id === item.Id);

    if (normalToRemove) {
      setNormalParticipants((old) => old.filter((x) => x.Id !== item.Id));
      setNewParticipants((old) => [...old, normalToRemove]);
    }
  };

  const handleMove = (item: ICaseParticipant, toCc: boolean) => {
    const newSource = newParticipants.find((x) => x.Id === item.Id);
    const normalSource = normalParticipants.find((x) => x.Id === item.Id);

    if (newSource) {
      if (!toCc) {
        setNormalParticipants((old) => [...old, newSource]);
      }
      setNewParticipants((old) => old.filter((x) => x.Id !== item.Id));
    }

    if (normalSource) {
      setNormalParticipants((old) => old.filter((x) => x.Id !== item.Id));
    }
  };

  const handleAfterEdit = (item: ICaseParticipant) => {
    const normalSource = normalParticipants.find((x) => x.Id === item.Id);

    if (normalSource) {
      const toReplace = [...normalParticipants];
      toReplace[normalParticipants.indexOf(normalSource)] = item;
      setNormalParticipants(toReplace);
      console.log("Setting", toReplace);
    }
  };

  const [{ isOver }, drop] = useDrop({
    accept: "participant",
    drop: onDrop,
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
  });

  const commit = () => {
    normalParticipants.forEach((p) => {
      p.Group = CaseParticipantGroup.Normal;
      if (typeof p.Id === "string") {
        p.Id = null;
      }
    });

    caseData.Participants = [...normalParticipants];

    saveCase(caseData, {
      onSuccess() {
        toggle(false);
      },
    });
  };

  useEffect(() => {
    if (pack) {
      compareParticipants(
        {
          CaseId: caseId,
          ThreadId: null,
          Items: [
            {
              Id: pack.Id,
              Kind: pack.Kind,
            },
          ],
        },
        {
          onSuccess(data) {
            data.data.New.forEach((d) => {
              d.Id = randomString();
            });
            setNewParticipants(data.data.New);
            setNormalParticipants(data.data.Existing);
          },
        },
      );
    }
  }, []);

  return (
    <div className={classNames(styles.addParticipantsWindow)}>
      {position === "left" && (
        <div className={styles.title}>
          <div>{t("participants.fetchSubjects")}</div>{" "}
          <CloseIcon
            onClick={() => {
              toggle(false);
            }}
            className={styles.closeIcon}
          />
        </div>
      )}
      <div className={styles.main}>
        {position === "center" && (
          <div className={styles.hdr}>
            <div className={styles.img}>
              <TeamIcon></TeamIcon>
            </div>
            <div>{t("participants.fetchSubjects")}</div>
          </div>
        )}

        <div className={styles.grow}>
          <LayoutContext.Provider
            value={{
              sizes,
              setSizes,
            }}
          >
            <PanelGroup ref={ref} direction="vertical">
              {newParticipants.length > 0 && (
                <Panel defaultSize={50}>
                  <div className={styles.panel}>
                    <div className={styles.subtitle}>
                      {t("participants.newUnlinkedList")}
                    </div>

                    <div className={classNames(styles.list, styles.nopadding)}>
                      <ListControl
                        getItemId={(i) => i.Id}
                        items={newParticipants}
                        renderItem={(i) => {
                          const p = i as ICaseParticipant;

                          return (
                            <Participant
                              part={p}
                              showGroup={true}
                              showOptions={true}
                              onMove={handleMove}
                              onRemove={handleRemove}
                              afterEdit={handleAfterEdit}
                            ></Participant>
                          );
                        }}
                        selectedItems={selectedParticipants}
                        setSelectedItems={setSelectedParticipants}
                      ></ListControl>
                      {newParticipants.length === 0 && (
                        <div className={styles.empty}>
                          {!isLoading && (
                            <>{t("participants.allExistInCase")}</>
                          )}
                          {isLoading && <Spinner></Spinner>}
                        </div>
                      )}
                    </div>
                  </div>
                </Panel>
              )}
              <PanelResizeHandle
                onDragging={(isDraging) => {
                  setSizes({ ...sizes, isDraging });
                }}
                className={`${styles.splitter}`}
                id={"attachAttachments"}
              ></PanelResizeHandle>

              <Panel defaultSize={50}>
                <div className={styles.panel}>
                  <div className={styles.subtitle}>
                    {t("participants.addressList")}
                  </div>

                  <div
                    className={classNames(styles.list, styles.nopadding)}
                    ref={drop}
                  >
                    <ListControl
                      getItemId={(i) => i.Id}
                      items={normalParticipants}
                      renderItem={(i) => {
                        const p = i as ICaseParticipant;

                        return (
                          <Participant
                            part={p}
                            showGroup={false}
                            showOptions={true}
                            group={CaseParticipantGroup.Normal}
                            onMove={handleMove}
                            onRemove={handleRemove}
                            afterEdit={handleAfterEdit}
                          ></Participant>
                        );
                      }}
                      selectedItems={selectedNormalParticipants}
                      setSelectedItems={setSelectedNormalParticipants}
                    ></ListControl>
                    {normalParticipants.length === 0 && (
                      <div className={styles.empty}>
                        {!isLoading && (
                          <NotFoundScreen
                            size="medium"
                            title={t("participants.noSubjects")}
                            text={t("participants.searchOrAdd")}
                          />
                        )}
                        {isLoading && <Spinner></Spinner>}
                      </div>
                    )}
                    {isOver && (
                      <div className={styles.dropOver}>
                        <DropIcon></DropIcon>
                        {t("common.dropHere")}
                      </div>
                    )}
                  </div>
                </div>
              </Panel>
            </PanelGroup>
          </LayoutContext.Provider>
        </div>
        <div className={classNames(styles.footer, styles.noborder)}>
          <div className={styles.buttonWrapper}>
            <HollowButton
              onClick={() => {
                toggle(false);
              }}
              text={t("common.cancel")}
            />
            <Button
              onClick={() => commit()}
              text={t("common.add")}
              disabled={isSavingCase}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const AttachToCaseModalNew = () => {
  const { t } = useTranslation();
  useParams();
  const navigate = useNavigate();
  const auth = useAuth();
  const { mutate: attachToCase } = casesService.useAttachToCase();
  const { mutate: attachManyToCase } = casesService.useAttachManyToCase();
  const userId = getUserId(auth.user!);
  const { modals, setModals } = useContext(ModalsManagerContext);
  const [c, setC] = useState<ICaseSimple | null>(null);
  const { packages, setPackages } = useContext(PackagesContext);
  const { casePackages, setCasePackages } = useContext(CaseChatContext);
  const { converstation, setConverstation } = useContext(ConverstationContext);
  const { dossierFiles, setDossierFiles } = useContext(DossierFilesContext);
  const { cases, setCases } = useContext(CasesContext);
  const { threadPackages, setThreadPackages } =
    useContext(PackageThreadContext);

  const currentWorkspaceId = getWorkspaceId();
  const { data: workspaceData } =
    workspaceService.useGetWorkspace(currentWorkspaceId);

  const [autoShare, setAutoShare] = useState(false);
  const {
    blob,
    removeBlob,
    create,
  } = usePDF();

  const [tags, setTags] = useState<ITag[]>([]);

  const addNewTag = (tag: ITag | null) => {
    const isTag = tags.find((etag) => etag.Name === tag!.Name);
    if (isTag) return;
    setTags([...tags, tag!]);
  };

  const handleRemoveTag = (tag: ITag) =>
    setTags(tags.filter((etag) => tag.Name !== etag.Name));

  const [allAttachments, setAllAttachments] = useState<IAttachment[]>(null);

  const [unusedAttachments, setUnusedAttachments] =
    useState<IAttachment[]>(null);

  const [usedAttachments, setUsedAttachments] = useState<
    IAttachToCaseFolderLink[]
  >([]);

  const [error, setError] = useState<string | null>(null);

  const [pack, setPack] = useState<IPackage>(null);
  const [dossierItem, setDossierItem] = useState<IDossierItem>(null);
  const [isAttachmentsExpanded, setIsAttachmentsExpanded] =
    useState<boolean>(true);

  const [attachmentsLocation, setAttachmentsLocation] =
    useState<string>("center");
  const [participnatsLocation, setParticipantsLocation] =
    useState<string>("center");

  const { options } = useContext(settingsContext);

  const [showProgress, setShowProgress] = useState<boolean>(false);
  const [progress, setProgress] = useState<number>(0);
  const [total, setTotal] = useState<number>(1);
  const normalise = (value) => (value * 100) / total;
  const { mutate: caseShare } = casesService.useShare();

  useEffect(() => {
    if (options) {
      const attL = options.find(
        (x) => x.Type === IOptionType.caseAttachAttachmentsLocation,
      );

      if (attL) {
        setAttachmentsLocation(attL.Value);
      }

      const partL = options.find(
        (x) => x.Type === IOptionType.caseAttachParticipantsLocation,
      );

      if (partL) {
        setParticipantsLocation(partL.Value);
      }
    }
  }, [options]);

  const [loading, setLoading] = useState(false);
  const [showDossier, setShowDossier] = useState(false);
  const [showParticipantsModal, setShowParticipantsModal] = useState(false);

  const [, setShowAttachments] = useState<boolean>(false);
  const attListRef = useRef(null);

  const [showApprovePICase, setShowApprovePICase] = useState<boolean>(false);
  const isMovingThread =
    pack?.Case?.Id && pack?.Thread?.Id && pack?.Thread?.Count > 1;

  useOnClickOutside(attListRef, () => {
    setShowAttachments(false);
  });

  const closeModal = () => {
    localStorage.removeItem("attach");
    setModals({ ...modals, hide: true });
  };

  const compile = (pack: IPackage) => {
    return new Promise(async (resolve, reject) => {
      try {
        const myKeys = await getKeys(userId!);

        const list = await axiosInstance.get(
          `/list?id=${pack.Id}&Kind=${pack.Kind}`,
        );

        if (!list) {
          throw new Error("No key");
        }

        const privateKey = list?.data?.ObjectKeys?.at(0) as IKey;
        let parentKey: IKey = null;

        if (privateKey?.ParentKeyId) {
          parentKey = list?.data?.Keys.find(
            (k) => k.Id === privateKey.ParentKeyId,
          );
        }

        let newPrivateKey: string | null = null;
        let newPublicKey: string | null = null;
        if (pack.EncryptionKeyId) {
          const decryptedPrivateKey = await decryptPrivateKey(
            myKeys!,
            privateKey,
            privateKey.EmptyPassphrase,
            parentKey,
          );
          const response = await axiosInstance.get(`/case/keys?id=${c?.Id}`);
          const publicKey = response.data[0].PublicKey;

          if (!publicKey) {
            throw new Error("No key");
          }

          const decryptedPublicKey = await readFileFromBase64(
            publicKey,
            "application/other",
          );
          const s = await openpgp.key.read(new Uint8Array(decryptedPublicKey));

          const { message } = await openpgp.encrypt({
            message: await openpgp.message.fromBinary(decryptedPrivateKey.data),
            publicKeys: [s.keys[0]],
            armor: false,
          });
          const uint8 = await new Uint8Array(message.packets.write());
          newPrivateKey = await readAsBase64(uint8);
          newPublicKey = await readAsBase64(new Uint8Array(decryptedPublicKey));
        } else if (pack.Kind === ItemKind.Email && !pack.EncryptionKeyId) {
          const response = await axiosInstance.get(`/case/keys?id=${c?.Id}`);
          const casePublicKey = response.data[0].PublicKey;
          const newKey = await generateSingleBinary(casePublicKey);

          newPrivateKey = newKey.PrivateKey;
          newPublicKey = newKey.PublicKey;
        }

        resolve({
          CaseId: c.Id,
          ToAttachId: pack.Id,
          ToAttachKind: pack.Kind,
          ObjectKey: newPrivateKey,
          PublicKey: newPublicKey,
          ShowInDossier: false,
        });
      } catch (e) {
        reject(e);
      }
    });
  };

  const compileDossierItem = (pack: IDossierItem) => {
    return new Promise(async (resolve, reject) => {
      try {
        if (pack.Kind === ItemKind.DossierLink) {
          resolve({
            CaseId: c.Id,
            ToAttachId: pack.Id,
            ToAttachKind: pack.Kind,
            ObjectKey: null,
            PublicKey: null,
            ShowInDossier: false,
          });
          return;
        }

        const myKeys = await getKeys(userId!);

        const list = await axiosInstance.get(`/dossier?id=${pack.Id}`);

        if (!list) {
          throw new Error("No key");
        }

        const privateKey = list?.data?.ObjectKeys?.at(0) as IKey;
        let parentKey: IKey = null;

        if (privateKey?.ParentKeyId) {
          parentKey = list?.data?.Keys.find(
            (k) => k.Id === privateKey.ParentKeyId,
          );
        }

        let newPrivateKey: string | null = null;
        let newPublicKey: string | null = null;
        if (pack.EncryptionKeyId) {
          const decryptedPrivateKey = await decryptPrivateKey(
            myKeys!,
            privateKey,
            privateKey.EmptyPassphrase,
            parentKey,
          );
          const response = await axiosInstance.get(`/case/keys?id=${c?.Id}`);
          const publicKey = response.data[0].PublicKey;

          if (!publicKey) {
            throw new Error("No key");
          }

          const decryptedPublicKey = await readFileFromBase64(
            publicKey,
            "application/other",
          );
          const s = await openpgp.key.read(new Uint8Array(decryptedPublicKey));

          const { message } = await openpgp.encrypt({
            message: await openpgp.message.fromBinary(decryptedPrivateKey.data),
            publicKeys: [s.keys[0]],
            armor: false,
          });
          const uint8 = await new Uint8Array(message.packets.write());
          newPrivateKey = await readAsBase64(uint8);
          newPublicKey = await readAsBase64(new Uint8Array(decryptedPublicKey));
        } else if (pack.Kind === ItemKind.Email && !pack.EncryptionKeyId) {
          const response = await axiosInstance.get(`/case/keys?id=${c?.Id}`);
          const casePublicKey = response.data[0].PublicKey;
          const newKey = await generateSingleBinary(casePublicKey);

          newPrivateKey = newKey.PrivateKey;
          newPublicKey = newKey.PublicKey;
        }

        resolve({
          CaseId: c.Id,
          ToAttachId: pack.Id,
          ToAttachKind: pack.Kind,
          ObjectKey: newPrivateKey,
          PublicKey: newPublicKey,
          ShowInDossier: false,
        });
      } catch (e) {
        reject(e);
      }
    });
  };

  const handleAttach = (pack: IPackage) => {
    return new Promise(async (resolve) => {
      const d: any = await compile(pack);

      attachToCase(
        {
          CaseId: d.CaseId,
          ToAttachId: d.ToAttachId,
          ToAttachKind: d.ToAttachKind,
          ObjectKey: d.ObjectKey,
          PublicKey: d.PublicKey,
          ShowInDossier:
            d.ShowInDossier ||
            (usedAttachments != null && usedAttachments.length > 0),
          Dossier: usedAttachments,
          TagIds: tags.map((t) => t.Id),
        },
        {
          onSuccess: () => {
            resolve(true);
          },
          onError: (data) => {
            // resolve(true);

            notification({
              type: ENotificationType.ERROR,
              title: t("errors.occurred"),
              text: t("errors.somethingWentWrong"),
            });
            throw new Error(`Odpowiedź z BE: ${data}`);
          },
        },
      );
    });
  };

  const handleAttachDossier = (dossierItem: IDossierItem) => {
    return new Promise(async (resolve) => {
      const d: any = await compileDossierItem(dossierItem);

      attachToCase(
        {
          CaseId: d.CaseId,
          ToAttachId: d.ToAttachId,
          ToAttachKind: dossierItem.Kind,
          ObjectKey: d.ObjectKey,
          PublicKey: d.PublicKey,
          ShowInDossier:
            d.ShowInDossier ||
            (usedAttachments != null && usedAttachments.length > 0),
          Dossier: usedAttachments,
          TagIds: tags.map((t) => t.Id),
        },
        {
          onSuccess: () => {
            resolve(true);
          },
          onError: (data) => {
            // resolve(true);

            notification({
              type: ENotificationType.ERROR,
              title: t("errors.occurred"),
              text: t("errors.somethingWentWrong"),
            });
            throw new Error(`Odpowiedź z BE: ${data}`);
          },
        },
      );
    });
  };

  const { messages, setMessages } = useThreadStore();

  const attachThread = async (pack: IPackage) => {
    const listResponse = await axiosInstance(
      `/list?ThreadId=${pack.Thread?.Id}`,
    );
    const list = listResponse.data;
    const newPacks = [...packages];
    const threadPacks = [...threadPackages];

    const objects = [];

    setShowProgress(true);
    setTotal((old) => old + list.Items.length);
    //setProgress(0);

    for (const p of list.Items as IPackage[]) {
      const object = await compile(p);
      objects.push(object);
      const el = newPacks.find((a) => a.Id === p.Id);
      const el2 = threadPacks.find((a) => a.Id === p.Id);

      if (el) {
        el.Case = c;
      }

      if (el2) {
        el2.Case = c;
      }

      if (p.Thread?.Id) {
        if (messages[p.Thread.Id]) {
          const toUpdate = [...messages[p.Thread.Id]];
          const t = toUpdate.find((a) => a.Id === p.Id);
          if (t) {
            t.Case = c;

            if (tags.length > 0) {
              t.TagIds = [...(t.TagIds ?? []), ...tags.map((t) => t.Id)];
            }

            setMessages(p.Thread.Id, toUpdate);
          }
        }
      }
      setProgress((old) => old + 1);
    }

    attachManyToCase({
      CaseId: c!.Id,
      ThreadId: pack.Thread!.Id,
      Items: objects.map((o: any) => {
        return {
          Id: o.ToAttachId,
          Kind: o.ToAttachKind,
          ObjectKey: o.ObjectKey,
          PublicKey: o.PublicKey,
        };
      }),
      ShowInDossier: usedAttachments != null && usedAttachments.length > 0,
      Dossier: usedAttachments,
      TagIds: tags.map((t) => t.Id),
    });

    setPackages(newPacks);
    setThreadPackages(threadPacks);
    if (move) {
      const newCasePackages = [...casePackages];
      setCasePackages(newCasePackages.filter((x) => x.Id !== pack.Id));

      const newConversationPackages = [...converstation];
      setConverstation(newConversationPackages.filter((x) => x.Id !== pack.Id));
    }
  };

  const handleShareCase = async () => {
    const response = await axiosInstance.get(`/case?id=${c?.Id}`);
    const encryptionKey = response.data.Keys[0];

    const keys = await Promise.all(
      workspaceData.data.Members.filter((x) => x.UserId !== null).map(
        async (m) => {
          const uint = await reEncrypt(userId, m.UserId, encryptionKey);
          const readyToSend = await readAsBase64(uint);

          return {
            Id: encryptionKey.Id,
            Key: readyToSend,
            ReceiverId: m.UserId,
          };
        },
      ),
    );

    caseShare(
      {
        CaseId: c.Id,
        Keys: keys,
      },
      {
        onSuccess: () => {
          const newCases = [...cases];
          const toupdate = newCases.find((cc) => cc.Id === c.Id);
          if (toupdate) {
            toupdate.IsShared = true;
            setCases(newCases);
          }
        },
      },
    );
  };

  const handleTryAttach = async () => {
    try {
      setError(null);
      setLoading(true);
      const pack = localStorage.getItem("package");
      const packs = localStorage.getItem("packages");
      const dossierItem = localStorage.getItem("dossierItem");

      const newPacks = [...packages];

      setProgress(0);

      // jeżeli zaznaczona była grupa przesyłek
      if (packs) {
        const parsed = JSON.parse(packs) as IPackage[];
        setShowProgress(true);
        setTotal(parsed.length);
        setProgress(0);
        for (const item of parsed) {
          if (item.Thread) {
            await attachThread(item);
          } else {
            await handleAttach(item);
            setProgress(progress + 1);
          }
        }
        localStorage.removeItem("packages");
        localStorage.removeItem("package");

        if (autoShare && currentWorkspaceId && c.Id) {
          handleShareCase();
        }

        setModals({ ...modals, hide: true });
        return;
      }
      // jeżeli zaznaczona była pojedyncza przesyłka
      else if (pack) {
        setTotal(0);
        const item = JSON.parse(pack);

        if (item.Thread) {
          await attachThread(item);
        } else {
          await handleAttach(item);
        }

        localStorage.removeItem("package");
        localStorage.removeItem("attach");

        const newPack = newPacks.find((p) => p.Id === item.Id);

        if (newPack) {
          newPack.Case = c as ICaseSimple;

          if (tags.length > 0) {
            newPack.TagIds = [
              ...(newPack.TagIds ?? []),
              ...tags.map((t) => t.Id),
            ];
          }

          setPackages(newPacks);
        }

        if (move) {
          const newCasePackages = [...casePackages];
          setCasePackages(newCasePackages.filter((x) => x.Id !== item.Id));

          const newConversationPackages = [...converstation];
          setConverstation(
            newConversationPackages.filter((x) => x.Id !== item.Id),
          );
        }

        if (autoShare && currentWorkspaceId && c.Id) {
          handleShareCase();
        }

        setModals({ ...modals, hide: true });
      } else if (dossierItem) {
        setTotal(0);
        const item = JSON.parse(dossierItem) as IDossierItem;

        await handleAttachDossier(item);

        localStorage.removeItem("dossierItem");

        const newDossierFiles = [...dossierFiles];

        const newDossierItem = dossierFiles.find((p) => p.Id === item.Id);

        if (newDossierItem) {
          newDossierItem.CaseId = c.Id;
          setDossierFiles(newDossierFiles);
        }

        if (autoShare && currentWorkspaceId && c.Id) {
          handleShareCase();
        }

        setModals({ ...modals, hide: true });
      }
    } catch (e) {
      logError(`[AttachCaseModal] CaseId: ${c?.Id}, Exception: ${e}`, true);
      setError(`${t("errors.caseBindingError")}: ${e}`);

      notification({
        type: ENotificationType.ERROR,
        title: t("errors.somethingWentWrongTitle"),
        text: t("errors.tryAgainLater"),
      });
    } finally {
      setLoading(false);
    }
  };

  const handleAttachmentChecked = (
    attachment: IAttachment,
    checked: boolean,
  ) => {
    console.log("HandleAttachmentChecked", attachment, checked);
    if (checked) {
      setUsedAttachments([...usedAttachments, { AttachmentId: attachment.Id }]);
      setUnusedAttachments([
        ...unusedAttachments.filter((x) => x.Id !== attachment.Id),
      ]);
    } else {
      setUsedAttachments([
        ...usedAttachments.filter((x) => x.AttachmentId !== attachment.Id),
      ]);
      setUnusedAttachments([
        ...unusedAttachments,
        ...allAttachments.filter((x) => x.Id === attachment.Id),
      ]);
    }
  };

  const showDossierFolders = () => {
    if (!c) return;
    setShowDossier(true);
  };

  const showParticipants = () => {
    if (!c) return;

    setShowParticipantsModal(true);
  };

  const handleCaseSelected = (c?: ICaseSimple) => {
    setC(c);

    // „Najpierw Teczka, potem panel" — po poprawnym wskazaniu teczki automatycznie
    // otwórz panel połączony (Załączniki + Dodaj do Dossier z folderami teczki).
    if (c) {
      setShowDossier(true);
    }

    if (
      c &&
      (pack?.Kind === ItemKind.CourtPortalDeliverance ||
        pack?.Kind === ItemKind.CourtPortalDocument)
    ) {
      if (!pack.Case?.Id) {
        setShowApprovePICase(true);
      }
    }
  };

  const handleCourtPortalCase = () => {};

  const [move, setMove] = useState(false);
  const [dossier, setDossier] = useState(false);

  useEffect(() => {
    const pack = localStorage.getItem("package");
    const attach = localStorage.getItem("attach");
    const isMove = localStorage.getItem("move");
    const dossierItem = localStorage.getItem("dossierItem");

    if (isMove) {
      setMove(true);
      localStorage.removeItem("move");
    }

    if (pack) {
      const uPack = JSON.parse(pack);
      const newPacks = [...packages];
      const newPack = newPacks.find((p) => p.Id === uPack.Id);

      if (newPack) {
        setPack(newPack);

        if (newPack.Attachments) {
          if (attach) {
            setDossier(true);
            const uAttachment = JSON.parse(attach);

            setAllAttachments(newPack.Attachments);

            setUnusedAttachments(
              newPack.Attachments.filter((a) => a.Id !== uAttachment.Id),
            );
            setUsedAttachments(
              newPack.Attachments.filter((a) => a.Id === uAttachment.Id).map(
                (a) => ({
                  AttachmentId: a.Id,
                  FolderId: null,
                }),
              ),
            );
          } else {
            setUnusedAttachments([]);
            setUsedAttachments(
              newPack.Attachments.map((a) => ({
                AttachmentId: a.Id,
                FolderId: null,
              })),
            );
            setAllAttachments(newPack.Attachments);
          }
        } else {
          setUnusedAttachments([]);
          setAllAttachments([]);
        }

        if (newPack.Case) {
          setC(newPack.Case);
        }
      } else {
        // pojedyncza wiadomośc z wątku, więc nie ma jej w packages
        setPack(uPack);
        setUnusedAttachments([uPack.Attachments]);
      }
    } else if (dossierItem) {
      const uDossierItem = JSON.parse(dossierItem) as IDossierItem;
      setDossierItem(uDossierItem);
      setUnusedAttachments([
        {
          ...uDossierItem,
          Format: "",
          ContentType: uDossierItem.FileContentType,
          Size: uDossierItem.FileSize,
          ShowInDossier: 0,
          Uri: uDossierItem.FileUri,
          FileName: uDossierItem.FileName ?? "",
          EncryptionKeyId: uDossierItem.EncryptionKeyId!,
          Label: uDossierItem.FileName ?? "",
        },
      ]);
    }
  }, []);

  useEffect(() => {
    if (unusedAttachments != null && unusedAttachments.length === 0) {
      setShowAttachments(false);
    }
  }, [unusedAttachments]);

  // useEffect(() => {
  //   if (showDossierFolders) {
  //     setFoldersTmp(folders);
  //     setUsedAttachmentsTmp(usedAttachments);
  //   }
  // }, [showDossierFolders]);

  return (
    <>
      <ModalLayout
        dock={DockPosition.DISABLED}
        off={true}
        customX={8}
        customY={0}
        ignore
        isAnimation
        fullHeight={true}
        name="attachCase"
      >
        <div className={styles.wrapper} data-attachcase-modal>
          <div className={styles.title}>
            {move
              ? !dossier
                ? t("modals.moveToCase")
                : t("modals.linkToDossier")
              : t("modals.linkToCase")}
            <CloseIcon
              onClick={() => {
                closeModal();
              }}
              className={styles.closeIcon}
            />
          </div>
          <div className={styles.content}>
            <SearchCasesNew
              settedCase={c}
              setAddNewEntity={() => {}}
              onChoose={(cas) => handleCaseSelected(cas)}
              allowCreateNew={c === null}
            />

            <div className={styles.buttons}>
              {!dossierItem && (
                <div
                  onClick={showParticipants}
                  className={classNames(
                    styles.borderButton,
                    !c ? styles.disabled : "",
                  )}
                >
                  <TeamIcon className={styles.icon} /> {t("participants.title")}
                </div>
              )}

              <SearchLabel
                label={t("common.tag")}
                type={TagType.Incoming}
                onChoose={addNewTag}
              />
            </div>

            <div className={styles.tags}>
              {!!tags.length && (
                <>
                  {tags.map((tag) => (
                    <TagBadge
                      useBigChip
                      key={tag.Id}
                      tag={tag}
                      onRemove={handleRemoveTag}
                    />
                  ))}
                </>
              )}
            </div>

            {!!allAttachments?.length && (
              <div className={styles.attachments}>
                <div className={styles.attHdr}>
                  <div className={styles.left}>
                    {t("documents.attachments")}{" "}
                    <div
                      onClick={(e) => {
                        setIsAttachmentsExpanded(!isAttachmentsExpanded);
                        e.stopPropagation();
                      }}
                      className={styles.expanderWrapper}
                    >
                      <FontAwesomeIcon
                        className={classNames(styles.expander)}
                        icon={isAttachmentsExpanded ? faCaretDown : faCaretUp}
                      />
                    </div>
                  </div>
                  <div className={styles.right}>
                    {((unusedAttachments != null &&
                      unusedAttachments.length > 0) ||
                      usedAttachments.length > 0) && (
                      <Tooltip
                        title={
                          !c ? t("attachCase.selectCaseFirst") : t("attachCase.linkAttachments")
                        }
                      >
                        <div
                          onClick={showDossierFolders}
                          className={classNames()}
                        >
                          <AttachIcon className={styles.icon} />
                        </div>
                      </Tooltip>
                    )}
                  </div>
                </div>
                {isAttachmentsExpanded && (
                  <div className={styles.attList}>
                    <ListControl
                      getItemId={(i) => i.Id}
                      items={allAttachments}
                      renderItem={(i) => {
                        const attach = i as IAttachment;

                        return (
                          <PackageAttachment
                            className={styles.attachment}
                            key={attach.Id}
                            onDownload={() => {}}
                            onPreview={() => create(pack.Id, attach, pack.Kind)}
                            handleDoubleClick={(attach) => {
                              const previewLocation = options.find(
                                (x) =>
                                  x.Type ===
                                  IOptionType.caseAttachAttachmentsLocation,
                              );

                              if (
                                !previewLocation ||
                                previewLocation.Value !== "left"
                              ) {
                                // decryptPackageAndSetBlob({
                                //   FileName: attach.FileName,
                                //   EncryptionKeyId: attach.EncryptionKeyId,
                                //   Uri: attach.Uri,
                                //   Kind: pack.Kind,
                                // });
                                // setShowPreview(true);
                              } else {
                                const newUrl = `${
                                  window.location.pathname
                                }?pdf=${pack.Id}:${attach.FileName.replace(
                                  ":",
                                  "",
                                )}:${attach.Uri ?? attach.Id}:${attach.Kind}:${
                                  attach.EncryptionKeyId
                                }`;
                                navigate(newUrl);
                              }
                            }}
                            onNewWindow={() => {}}
                            attachment={attach}
                            isInDossier={Boolean(attach.ShowInDossier)}
                            onAddDossier={() => {}}
                            disableMenu={true}
                            sizeInColumn={true}
                            showCheckbox={true}
                            isChecked={
                              !!usedAttachments.find(
                                (x) => x.AttachmentId === attach.Id,
                              )
                            }
                            handleAttachmentChecked={handleAttachmentChecked}
                          />
                        );
                      }}
                      selectedItems={[]}
                      setSelectedItems={() => {}}
                    ></ListControl>
                  </div>
                )}
              </div>
            )}
          </div>

          {isMovingThread && c && c?.Id !== pack?.Case?.Id && (
            <div className={styles.warn}>
              <div className={styles.warnContent}>
                {t("attachCase.threadMoveWarning")}
              </div>
            </div>
          )}

          {currentWorkspaceId && !c?.IsShared && (
            <div className={styles.share}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={autoShare}
                      onChange={(e) => {
                        setAutoShare(e.target.checked);
                        //saveAutoShare(e.target.checked);
                      }}
                    />
                  }
                  label={t("attachCase.shareWithTeam")}
                ></FormControlLabel>
              </FormGroup>
            </div>
          )}

          {showProgress && (
            <div className={styles.progress}>
              <LinearProgress
                variant="determinate"
                value={normalise(progress)}
              />
            </div>
          )}
          {error && (
            <div className={styles.error}>
              <b>{t("errors.somethingWentWrong")}</b>
              <div>{error}</div>
            </div>
          )}

          <div className={styles.footer}>
            <div className={styles.buttonWrapper}>
              <Button
                loading={loading}
                disabled={!c}
                onClick={handleTryAttach}
                text={move && !dossier ? t("common.move") : t("common.link")}
              />
            </div>
          </div>

          {showParticipantsModal && participnatsLocation !== "center" && (
            <div className={styles.wrapperCover}>
              <AttachToCaseModalParticipants
                toggle={(c) => setShowParticipantsModal(c)}
                pack={pack}
                caseId={c?.Id}
                position="left"
              ></AttachToCaseModalParticipants>
            </div>
          )}

          {showDossier && attachmentsLocation !== "center" && (
            <div className={styles.wrapperCover}>
              <AttachToCaseModalAttachments
                toggle={(c) => setShowDossier(c)}
                c={c}
                pack={pack}
                unusedAttachments={unusedAttachments}
                setUnusedAttachments={setUnusedAttachments}
                setUsedAttachments={setUsedAttachments}
                usedAttachments={usedAttachments}
                className={styles.nomodal}
                position="left"
              ></AttachToCaseModalAttachments>
            </div>
          )}
        </div>
      </ModalLayout>

      {showDossier && attachmentsLocation === "center" && (
        <div className={styles.modalBg}>
          <AttachToCaseModalAttachments
            toggle={(c) => setShowDossier(c)}
            c={c}
            pack={pack}
            unusedAttachments={unusedAttachments}
            setUnusedAttachments={setUnusedAttachments}
            setUsedAttachments={setUsedAttachments}
            usedAttachments={usedAttachments}
            position="center"
          ></AttachToCaseModalAttachments>
        </div>
      )}

      {showParticipantsModal && participnatsLocation === "center" && (
        <div className={styles.modalBg}>
          <AttachToCaseModalParticipants
            toggle={(c) => setShowParticipantsModal(c)}
            pack={pack}
            caseId={c?.Id}
            position="center"
          ></AttachToCaseModalParticipants>
        </div>
      )}

      {showApprovePICase && (
        <div className={styles.modal}>
          <div className={styles.bg}></div>
          <div className={classNames(styles.modalCenter, styles.small)}>
            <div className={styles.iconWrapper}>
              <CourtIcon className={styles.icon}></CourtIcon>
            </div>
            <div className={styles.title}>{t("courtPortal.caseDataTitle")}</div>
            <div className={styles.message}>
              {t("courtPortal.mergeCaseMessage")}
            </div>
            <div className={styles.buttons}>
              <HollowButton
                text={t("common.cancel")}
                onClick={() => setShowApprovePICase(false)}
              ></HollowButton>
              <Button
                text={t("courtPortal.merge")}
                onClick={() => handleCourtPortalCase()}
              ></Button>
            </div>
          </div>
        </div>
      )}

      {blob && (
        <ShowPreviewModal toggle={removeBlob} blob={blob} isMobile={false} />
      )}
    </>
  );
};

export default AttachToCaseModalNew;
